import Vue from 'vue';
import Loader from './components/utils/Loader';
import App from './App';
import i18n from './lang';

Vue.config.productionTip = false;

Vue.component('Loader', Loader);

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#access-card');
